import * as React from "react";
import {
    Navbar,
    Container,
    Button,
    Row, Col,
    Input
} from 'reactstrap';

import _, { values } from 'underscore';
import AsyncLock from 'async-lock';

import { Link } from 'react-router-dom';
import CarouselImage from './CarouselImage';
import DialogBase from "../Base/DialogBase";
import InputText from '../FormParts/InputText';
import InputNumber from '../FormParts/InputNumber';
import InputSelect from '../FormParts/InputSelect';
import InputSelectClearUndefined from '../FormParts/InputSelectClearUndefined';
import GoogleDrive from '../../common/GoogleDrive';
import Request from '../../common/Request';

import {googleMapKey} from  '../../variables/apikeys';
import WithRole from '../FormParts/ButtonWithRole';
import {
    cst_request_parking_status,
    cst_route_map_parking_flag
} from '../../variables/codes_map';
import ImageControl from '../FormParts/ImageControl'
import Definition from '../../common/Definition'
import isDisabledByRole from '../../common/DisabledRoleCheck';
import { getErrorCodes, GetMessage } from '../../variables/message';
import Format from '../../common/Format';
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export let google;
let lock = new AsyncLock();
let scriptLoaded = false;

const PIN_COLOR = {
    CURRENT_POSITION_PIN: 'purple', // 現場PIN
    EMPHASIS_PIN: 'black',　// 強調するPIN
    PROHIBITED_PIN: 'red'
};

// request_parking_status
// 0:未確認、1:空有、2:満車（空予定）、3:満車、4:短期不可、5:不特定不可、6:外部不可、7:契約不可、8:閉鎖、9:電話不通、10：保留、11:見積登録候補保存済み
/*
　未確認 の場合 ： yellow
　空有 の場合 ： gold
　満車（空予定） の場合 ： orange
　満車 の場合 ： turquoise
　短期不可 の場合 ： blue
　不特定不可 の場合 ： midnightblue
　外部不可 の場合 ： palegoldenrod
　契約不可 の場合 ： lightgreen
　閉鎖 の場合 ： green
　電話不通 の場合 ： deepgreen
　保留 の場合 ： pink
　見積登録候補保存済み の場合 ： red
　アイコンをフォーカス（クリック）した状態の場合 ： black
*/
const PARKING_STATUS_PIN_COLOR_MAP = {
    0: 'yellow',
    1: 'gold',
    2: 'orange',
    3: 'turquoise',
    4: 'blue',
    5: 'midnightblue',
    6: 'palegoldenrod',
    7: 'lightgreen',
    8: 'green',
    9: 'darkgreen',
    10: 'pink',
    11: 'red'
};

const PIN_TYPE = {
    CURRENT_POSITION_PIN: 0,
    REGISTERED_PIN: 1,
    MANUAL_PIN: 2,
    REGISTERED_ADD_PIN: 3,
    REGISTERED_CUST_PIN: 4,
    PROHIBITED_PIN: 5
};

/**
 * 調査詳細画面用
 */
export default class GoogleMapEx extends React.Component {
    mapRef = React.createRef();
    map;
    marker_clusterer;
    searchManager;
    dynamic_pininfo = null; // 画面クリックでつけたピン　center_pinで指定されたピン
    tooltip;
    infobox_for_dynamic_pin;
    tooltipTemplate = `<div style="background-color:white;min-height:80px;width:130px;padding:5px;text-align:center">
        <div style="min-height:25px;overflow:hidden"><b>{title}</b></div>
        <div style="width:120px"><img src="{img}" style="max-height:70px;width:100%;"/></div>
    </div>`
    
    constructor(props) {
        super(props);

        this.state = {
            data:[],
            googleMapKey: googleMapKey,
            address: '',
            editable: this.props.editable ? true : false,
            // editself: this.props.editself ? true : false, // ダイアログ表示で自前の編集保存機能を有効にする
            pin_color_guide_open: false,
            request_ulid: this.props.request_ulid ? this.props.request_ulid : null,
            clickSave: false,
            supplier_data:{
                selected_supplier_id: null,
                suppliers: [],
                error: undefined
            },
            selectingInfo: { 
                values:{
                    pin_type: PIN_TYPE.MANUAL_PIN,
                    parking_pictures:[]
                },
                errors:{},
                requiredData:{
                    parking_name : [GetMessage(2024)],
                    supplier_name : [GetMessage(2024)],
                    supplier_tel : [GetMessage(2024)],
                },
                history: []
            }, // 選択中の駐車場情報
            emphasisIds: [], // 強調表示するID一覧
            center_pin: this.props.center_pin ? this.props.center_pin : 2, // 0:ピンを立てない 1: Fixedピンを立てる（固定編集不可） 2: 動的PINを立てる
            center_processed: false, // centerの処理は値が変わっても初回だけやるためのフラグ（初回空っぽで2回目以降にデータが来た場合　2回めだけ処理する）
            mapOptions:{},
            sessionCheckInterval:undefined,
            editpin:{
                pin:{
                    metadata:{
                        default_lat: "",
                        default_lng: "",
                        default_color: "",
                        pin_type: "",
                        latitude: "",
                        longitude: "",
                    }
                },
                handlers:[],
            },
            allpins:[],
            isLoads: true,
        };
        // this.editConfirmDialog = React.createRef();
        this.editDialog = React.createRef();
        this.errorDialog = React.createRef();
        this.dialogConfirm = React.createRef();
        this.dialogSupplierUpdate = React.createRef();
        this.carouselImage = React.createRef();
        this.script = undefined
        this.setEmphasisIds = this.setEmphasisIds.bind(this);
        // this.setAddress = this.setAddress.bind(this);
        this.onClickMap = this.onClickMap.bind(this);
        this.onRightClickMap = this.onRightClickMap.bind(this);
        this.onClickPin = this.onClickPin.bind(this);
        this.onMouseOverPin = this.onMouseOverPin.bind(this);
        this.onMouseOutPin = this.onMouseOutPin.bind(this);
        this.onDragPin = this.onDragPin.bind(this);
        this.onDragStartPin = this.onDragStartPin.bind(this);
        this.onDragEndPin = this.onDragEndPin.bind(this);
        this.onClickSitePin = this.onClickSitePin.bind(this);
        this.onDragEndSitePin = this.onDragEndSitePin.bind(this);
        this.removePin = this.removePin.bind(this);
        this.addPin = this.addPin.bind(this);
        this.selectWithId = this.selectWithId.bind(this);
        this.initPins = this.initPins.bind(this);
        this.handleDataUpdated = this.handleDataUpdated.bind(this);
        this.clearDynamicPin = this.clearDynamicPin.bind(this);
        this.saveLeftSide = this.saveLeftSide.bind(this);
        this.moveToOrigin = this.moveToOrigin.bind(this)
        this.validateCallback = this.validateCallback.bind(this)
        this.parentUpdateSiteLocation = this.parentUpdateSiteLocation.bind(this)
        this.addSvgPinMarker = this.addSvgPinMarker.bind(this)
        this.editSvgPinMarker = this.editSvgPinMarker.bind(this);
        this.updateEditPin = this.updateEditPin.bind(this);
        // 2022-06-22 yj.sato
        this.addCart = this.addCart.bind(this);
        // 2025-02-17 
        this.orgFloor = this.orgFloor.bind(this);

        this.searchData = {
            values:{
              search_distance: 500,
            },
            errors:{},
            requiredData:{}
        };
        this.bounds = null;
        this.prev_bounds = null;
        this.data = [];
        this.current_position_pin = null;
    }

    componentDidMount() {
        if (window.GooglemapRefreshIsNeeded) {
            window.location.reload()
        }
        this.loadGoogleApi().then(() => {
            this.initMap();
        });
    }

    componentWillUnmount(){
        clearTimeout(this.state.sessionCheckInterval)
        this.setState({
            sessionCheckInterval:undefined
        })
    }

    componentDidUpdate(prevProps) {
        if (this.map && scriptLoaded){
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.props.requestData)
        }
    }

    async search(searchData = null) {
        if(this.bounds == null || this.state.searchLockFlag == true) {
            return;
        }
        // 延長の場合は対象の駐車場のみ選択可能とする
        const extend_estimate_flag = this.props.requestData.request_type === 2 ? true : undefined

        const center = {
            latitude: (this.props.requestData ? this.props.requestData.latitude : 0),
            longitude: (this.props.requestData ? this.props.requestData.longitude : 0)
        }
        var url = '/api/request/parking/unlimit';

        if (searchData != null) {
            this.searchData = searchData;
        }

        const params = {
            request_ulid: this.props.match.params.ulid,
            search_distance: 500,
            transshipment_flag: this.searchData.values.transshipment_flag,
            request_parking_status: this.searchData.values.request_parking_status,
            latitude: center.latitude,
            longitude: center.longitude,
            max_longitude: this.bounds.getNorthEast().lng(),
            max_latitude: this.bounds.getNorthEast().lat(),
            min_longitude: this.bounds.getSouthWest().lng(),
            min_latitude: this.bounds.getSouthWest().lat(),
            show_delete_data: '0',
            extend_estimate_flag
        };

        Request.get(url, params,
            res => {
                let old_data = this.data;
                this.data = res.data;

                // TODO マージもそこまでちらつきとか変わらないので一旦無効
                // if(searchData == null) {
                //     this.initPins(true, old_data);
                // } else {
                //     this.initPins();
                // }

                this.props.updateParkingList && this.props.updateParkingList(this.data);
                this.initPins(false,[],this.state.selectingInfo.ulid);

                if(this.state.isParking) {
                    // 左側パネル常時表示化でピン再読み込み時に再度選択情報を更新しないと　最新情報が反映されないため
                    // ここで同じピンを再選択
                    this.setSelectingInfo(this.state.selectingInfo.ulid);
                }
            })
        //      console.log(this.state.data);  
    }

    // 初期PINの配置や　データ変更に伴うPINの再配置
    // merge, old_data指定時は差分更新
    initPins(merge = false, old_data = [],ulid = undefined) {
        if (!this.map)
            return;

        //全pinを削除
        new Promise((resolve)=>{
            let add_target = this.data;
            if (merge) {
                // 新しいリストにしかないピン（追加対象）
                add_target = this.data.filter((d1) => {
                    return old_data.filter((d2) => { return d2.ulid == d1.ulid; }).length == 0;
                });
                // 古いリストにしかないピン（削除対象）
                let del_target = old_data.filter((d1) => {
                    return this.data.filter((d2) => { return d2.ulid == d1.ulid; }).length == 0;
                });
                if(add_target.length <= 0 && del_target <= 0) {
                    return;
                }

                if(this.state.allpins && Array.isArray(this.state.allpins)){
                    _.each(this.state.allpins, (value, index) => {
                        if(value.pin instanceof google.maps.Marker){
                            if(del_target.filter((d) => {return d.ulid == value.pin.metadata.ulid;}).length != 0) {
                                this.removePin(value,index);
                            }
                        }
                    });

                };
            } else {
                if(this.state.allpins && Array.isArray(this.state.allpins)){
                    _.each(this.state.allpins, (value, index) => {
                        if(value.pin instanceof google.maps.Marker){
                            this.removePin(value,index);
                        }
                    });

                };
            }

            if (this.data && Array.isArray(this.data)) {
                _.each(this.data, (value, index) => {
                    if (value.latitude && value.longitude) {
                        let location = {lat:value.latitude,lng:value.longitude}

                        // console.log('initPins >> ',  value)
                        const register_type = value.request_parking.register_type

                        // 追加取込か確認（sv_idがnullではない場合は追加取込駐車場）
                        let pinType = value.banned_flag == 1 ? PIN_TYPE.PROHIBITED_PIN
                            : register_type == 1 
                                ? PIN_TYPE.REGISTERED_CUST_PIN 
                                : value.sv_id == null 
                                    ? PIN_TYPE.REGISTERED_PIN 
                                    : PIN_TYPE.REGISTERED_ADD_PIN
                        this.addPin(location, {...value}, pinType);
                        
                    }
                });

            }
            // 現場位置PIN配置
            let center = this.props.center ? this.props.center : null;
            let location = {lat:center.latitude,lng:center.longitude}
            this.addPin(location, { project_ulid : this.props.requestData.project_ulid }, PIN_TYPE.CURRENT_POSITION_PIN,true,true);
            this.updateCenterPin();
            resolve();
        }).then(() => {
            // 非表示のPINをStateから消す
            let tmppins = this.state.allpins.filter((value) => (value.handlers.length > 0));
            this.marker_clusterer.clearMarkers();
            this.marker_clusterer.addMarkers(tmppins.map(value => value.pin));
            this.setState({allpins:tmppins},()=>{
                let setPin = false
                this.state.allpins.map((value)=>{
                    if(value.pin.metadata.ulid==ulid && ulid != undefined){
                        this.setState({
                            orgpins:value.pin
                        })
                        value.pin.setIcon(this.setSvg(PIN_COLOR.EMPHASIS_PIN));
                        setPin = true;
                    }}
                )
                if(!setPin){
                 this.setState({
                    selectingInfo:{
                        ...this.state.selectingInfo,
                        ulid:undefined
                    }
                 })
                }
            });

        });

    }

    updateCenterPin() {
        if(this.state.center_processed)
            return ;

        let mapOptions = { center: null };
        // let center_pin;
        let center = this.props.center ? this.props.center : null;

        if (center && center.latitude && center.longitude) {
            mapOptions.center = new google.maps.LatLng(center.latitude, center.longitude);
        } else {
            return;
        }            

        this.map.setCenter(mapOptions.center);

        if (this.state.address){
            this.geocodeQuery(this.state.address)
        }
        this.setState({ center_processed: true, mapOptions });

    }

    moveToOrigin(){
        // console.log("moveToOrigin");
        this.map.setCenter(this.state.mapOptions.center);
    }

    // 強調するデータのIDを設定
    setEmphasisIds(ids) {
        // this.setState({ emphasisIds: ids }, () => {
        //     for (var i = this.map.entities.getLength() - 1; i >= 0; i--) {
        //         var pin = this.map.entities.get(i);
        //         if (pin instanceof Microsoft.Maps.Pushpin) {
        //             if (pin.metadata && (pin.metadata.pin_type === PIN_TYPE.REGISTERED_PIN 
        //                 || pin.metadata.pin_type === PIN_TYPE.REGISTERED_ADD_PIN
        //                 || pin.metadata.pin_type === PIN_TYPE.REGISTERED_CUST_PIN)) {
        //                 if (this.state.selectingInfo.values.parking_ulid === String(pin.metadata.ulid)) {
        //                     pin.setOptions({
        //                         color: PIN_COLOR.EMPHASIS_PIN,
        //                         draggable: true
        //                     });
        //                 } else {
        //                     console.log('setEmphasisIds >>', pin.metadata)
        //                     const register_type = pin.metadata.request_parking.register_type
        //                     let color = register_type == 1 ? PIN_COLOR.REGISTERED_CUST_PIN : pin.metadata.sv_id == null ? PIN_COLOR.REGISTERED_PIN : PIN_COLOR.REGISTERED_ADD_PIN
        //                     pin.setOptions({
        //                         color: color
        //                     });
        //                 }
        //             } else if (pin.metadata && (pin.metadata.pin_type === PIN_TYPE.CURRENT_POSITION_PIN)) {
        //                 if(this.state.project_ulid === String(pin.metadata.project_ulid)){
        //                     pin.setOptions({
        //                         color: PIN_COLOR.EMPHASIS_PIN,
        //                         draggable: true
        //                     });
        //                 }
        //             }
        //         }
        //     }
        // });
    }

    // id(ulid)からピンを選択状態にし　左サイドを開く　このコンポーネント外からの操作用
    selectWithId(id) {
        this.setSelectingInfo(id)
    }

    pinColorGuideSwitch() {
        this.setState({
            pin_color_guide_open: !this.state.pin_color_guide_open
        })
    }

    // /**
    //  * 住所からピンを打つ
    //  */
    // setAddress(address) {
    //     // this.removePins();
    //     if (this.dynamic_pininfo){
    //         this.removePin(this.dynamic_pininfo);
    //     }
    //     this.setState({
    //         address
    //     })
    //     this.geocodeQuery(address);
    // }

    removePin(pininfo) {
        // console.log(pininfo);
        if (pininfo == null){
            return ;
        }
        if (Array.isArray(pininfo.handlers)) {
            _.each(pininfo.handlers, (item) => {
                google.maps.event.removeListener(item);
            });
        }
        pininfo.handlers = [];
        pininfo.pin.setMap(null);

    }

    setSvg(color){
        let path = "M82 464 c-51 -26 -77 -70 -77 -130 0 -43 7 -62 52 -136 29 -47 60 -105 68 -129 9 -24 18 -51 21 -59 3 -9 13 8 23 41 10 32 42 95 70 142 61 99 72 147 46 201 -35 73 -131 106 -203 70z"
        let size = { width: 30, height: 48}
        const svg = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${size.width}pt" height="${size.height}pt" viewBox="0 0 ${size.width} ${size.height}" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,${size.height}.000000) scale(0.100000,-0.100000)" fill="${color}" stroke="none">
        <path d="${path}" />
        </g></svg>`
        const iconSvgUrl = {url: `data:image/svg+xml,${encodeURIComponent(svg)}`, scaledSize: new window.google.maps.Size(size.width, size.height), labelOrigin: new window.google.maps.Point(15, 15),}

        return iconSvgUrl;
    }

    svgPinTag(props){
        let color = PIN_COLOR.EMPHASIS_PIN;
        switch (props.pintype) {
            case PIN_TYPE.CURRENT_POSITION_PIN:
                color = PIN_COLOR.CURRENT_POSITION_PIN;
                break;
            case PIN_TYPE.REGISTERED_PIN:
            case PIN_TYPE.REGISTERED_ADD_PIN:
            case PIN_TYPE.REGISTERED_CUST_PIN:
                var parking_status = props.parking_status == null ? 0 : props.parking_status;
                color = PARKING_STATUS_PIN_COLOR_MAP[parking_status]
                break;
            case PIN_TYPE.MANUAL_PIN:
                color = PIN_COLOR.EMPHASIS_PIN;
                break;
            case PIN_TYPE.PROHIBITED_PIN:
                color = PIN_COLOR.PROHIBITED_PIN;
                break;
        }
        let path = "M82 464 c-51 -26 -77 -70 -77 -130 0 -43 7 -62 52 -136 29 -47 60 -105 68 -129 9 -24 18 -51 21 -59 3 -9 13 8 23 41 10 32 42 95 70 142 61 99 72 147 46 201 -35 73 -131 106 -203 70z"
        let size = { width: 12, height: 18}
        return <span style={{ position: "relative"}}>
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width={size.width+'pt'} height={size.height+'pt'} viewBox={"0 0 30 48"} preserveAspectRatio="xMidYMid meet">
        <g transform={"translate(0.000000,48.000000) scale(0.100000,-0.100000)"} fill={color} stroke="none">
        <path d={path} />
        </g></svg>
        <span style={{ position: "absolute", left: 3, top: -7}}><font color="white" size="1">{props.pintype==PIN_TYPE.PROHIBITED_PIN?"禁":"●"}</font></span>
        </span>

    }

    editSvgPinMarker( pin, color, location=false){
        pin.setIcon(this.setSvg(color));

        if(location){
            // console.log(pin.metadata);
            let latLng = new google.maps.LatLng(pin.metadata.default_lat, pin.metadata.default_lng);            
            pin.setPosition(latLng);
            pin.setDraggable(false);
        }else{
            pin.setDraggable(true);
        }
    }

    addSvgPinMarker ( latLng, color="#8B0000", route_map_parking_flag = false, pin_type = null) {
        let marker = new window.google.maps.Marker({
            position: latLng,
            // draggable: true,
            map:this.map,
            icon: this.setSvg(color),
            label: {
                text: pin_type == PIN_TYPE.PROHIBITED_PIN ? "禁" : (route_map_parking_flag ? "★" : "●"),
                color: "#FFFFFF",
                fontSize: "20px"
            }
        })
        return marker
    }

    updateEditPin(){
        let editpin = this.state.editpin;
        let tmp = [];
        // console.log(editpin);

        _.each(this.state.data, (value, index) => {
            if (value.latitude && value.longitude) {
                if(editpin.pin != undefined && editpin.pin.metadata && value.ulid == editpin.pin.metadata.ulid){
                    let uppin = value;
                    uppin.latitude = editpin.pin.metadata.latitude;
                    uppin.longitude = editpin.pin.metadata.longitude;
                }
                tmp.push(value);
            }
        });
        if(editpin.pin != undefined){
            editpin.pin.metadata.default_lat = editpin.pin.metadata.latitude;
            editpin.pin.metadata.default_lng = editpin.pin.metadata.longitude;
        }
        this.setState({editpin: editpin, data: tmp});
    }


    async addPin(location, metadata = {}, pin_type = PIN_TYPE.MANUAL_PIN,mouseover=true,site=false) {
        let color = PIN_COLOR.EMPHASIS_PIN;
        switch (pin_type) {
            case PIN_TYPE.CURRENT_POSITION_PIN:
                color = PIN_COLOR.CURRENT_POSITION_PIN;
                break;
            case PIN_TYPE.REGISTERED_PIN:
            case PIN_TYPE.REGISTERED_ADD_PIN:
            case PIN_TYPE.REGISTERED_CUST_PIN:
                var parking_status = metadata.request_parking_status == null ? 0 : metadata.request_parking_status;
                color = PARKING_STATUS_PIN_COLOR_MAP[parking_status];
                break;
            case PIN_TYPE.MANUAL_PIN:
                color = PIN_COLOR.EMPHASIS_PIN;
                break;
            case PIN_TYPE.PROHIBITED_PIN:
                color = PIN_COLOR.PROHIBITED_PIN;
                break;
        }

        // var pin = new google.maps.Marker(markerOptions);
        var latlng = new google.maps.LatLng(location.lat, location.lng);
        var route_map_parking_flag = false;
        if(metadata.request_parking && metadata.request_parking.route_map_parking_flag) {
            route_map_parking_flag = metadata.request_parking.route_map_parking_flag == 1;
        }
        var pin = this.addSvgPinMarker(latlng,color,route_map_parking_flag,pin_type);
        pin.metadata = metadata;
        pin.metadata.pin_type = pin_type;
        pin.metadata.site_flag = site;
        pin.metadata.default_color = color;
        pin.metadata.default_lat = location.lat;
        pin.metadata.default_lng = location.lng;
        pin.metadata.latitude = location.lat;
        pin.metadata.longitude = location.lng;

        let handlers = [];
        if (this.state.editable && pin_type !== PIN_TYPE.CURRENT_POSITION_PIN) {
            handlers.push(google.maps.event.addListener(pin, 'click', (e)=>this.onClickPin(e,pin)));
            if(mouseover == true){
                handlers.push(google.maps.event.addListener(pin, 'mouseover' , (e)=>this.onMouseOverPin(e,pin)));
            }
            handlers.push(google.maps.event.addListener(pin, 'mouseout' , this.onMouseOutPin));
            handlers.push(google.maps.event.addListener(pin, 'drag', this.onDragPin));
            handlers.push(google.maps.event.addListener(pin, 'dragend', (e)=>this.onDragEndPin(e,pin)));
            handlers.push(google.maps.event.addListener(pin, 'dragstart', this.onDragStartPin));

        }

        if (this.state.editable && pin_type === PIN_TYPE.CURRENT_POSITION_PIN) {
            this.current_position_pin = pin;
            handlers.push(google.maps.event.addListener(pin, 'click', (e)=>this.onClickSitePin(e,pin)));
            handlers.push(google.maps.event.addListener(pin, 'dragend', this.onDragEndSitePin));
        }
        // this.map.entities.push(pin);
        let allpins = this.state.allpins;
        let res = { pin: pin, handlers: handlers }
        allpins.push(res);
        this.setState({allpins});
        return res;
    }

    onClickMap(e) {
        // this.clearDynamicPin();
    }

    clearDynamicPin() {
        this.tooltip.close();
        // this.closeTooltip();
        if (this.dynamic_pininfo){
            this.removePin(this.dynamic_pininfo)
        }
        this.infobox_for_dynamic_pin&&this.infobox_for_dynamic_pin.setOptions({ visible: false });
    }

    parentUpdateSiteLocation(){
        const { newSiteLocation } = this.state
        const { center } = this.props
        this.setState({
            mapOptions : {
                ...this.state.mapOptions,
                center : {
                    ...this.state.mapOptions.center,
                    latitude : newSiteLocation ? newSiteLocation.latitude : center.latitude,
                    longitude : newSiteLocation ? newSiteLocation.longitude : center.longitude
                }
            }
        }, () => {
            this.props.parentUpdateSiteLocation();
            this.search();
        })
    }

    async onRightClickMap(e) {
        this.clearDynamicPin();
        // if (this.dynamic_pininfo)
        //     this.removePin(this.dynamic_pininfo);
        this.props.onLocationChange && this.props.onLocationChange(e.latLng.lat(), e.latLng.lng());

        const location = {lat:e.latLng.lat(),lng:e.latLng.lng()}

        this.dynamic_pininfo = await this.addPin(location,{},PIN_TYPE.MANUAL_PIN,false);

        this.infobox_for_dynamic_pin.open({
            anchor:this.dynamic_pininfo.pin,
            map:this.map,
            shouldFocus: false,
        })


        
        this.setState({
            selectingInfo: {
                ...this.state.selectingInfo,
                values:{
                    ...this.state.selectingInfo.values,
                    ...this.dynamic_pininfo.pin.metadata,
                    parking_pictures:[]
                }
            }
        })
    }

    onClickPin(e,pin) {
        const {
            ulid
        } = pin.metadata
        this.setState({
            project_ulid: null
        },()=>{
            // console.log(this.state.orgpins);
            this.state.orgpins && this.state.orgpins.setIcon(this.setSvg(this.state.orgpins.metadata.default_color));
            this.setSelectingInfo(ulid,false,{},undefined,true)
        })
    }

    onMouseOverPin(e,pin) {

        this.openTooltip(pin);
    }

    onMouseOutPin(e,pin) {
        this.tooltip.close();
    }

    onDragPin(e) {
    }

    onDragStartPin(e) {
        this.tooltip.close();
    }

    onDragEndSitePin(e){
        const newSiteLocation = {latitude:e.latLng.lat(),longitude:e.latLng.lng()};
        this.setState({
            request_ulid : this.props.request_ulid,
            newSiteLocation : newSiteLocation
        })
    }
    onClickSitePin(e,pin){
        this.setState({
            project_ulid : pin.metadata.project_ulid
        }, () => {
            // console.log(pin);
            this.setSelectingInfo("",true,pin);
            this.clearDynamicPin();
        })
    }

    async onDragEndPin(e,pin) {
        
        const location = e.latLng;
        const metadata = pin.metadata;
        
        metadata.latitude = location.lat();
        metadata.longitude = location.lng();
        metadata.edited = true;

        const { site_distance_meter, site_distance_minute} = await this.calcDistance(location.lat(), location.lng())
        this.setState({
            selectingInfo: {
                ...this.state.selectingInfo,
                values:{
                    ...this.state.selectingInfo.values,
                    latitude: location.lat(),
                    longitude: location.lng(),
                    site_distance_meter,
                    site_distance_minute,
                    edited:true
                },
            }
        });

            // 情報表示領域が出てないとき、動的に付加したPINに吹き出しを追従させる
        if (metadata.pin_type === PIN_TYPE.MANUAL_PIN && !this.state.left_side_open) {
            this.openTooltip(pin);
        }        
        this.props.onLocationChange && this.props.onLocationChange(location.lat(), location.lng());

        // this.state.editself && this.editConfirmDialog.current.show();
    }

    openTooltip(pin) {
        let title = pin.metadata.parking_name ? pin.metadata.parking_name : '';
        let img = pin.metadata.parking_picture_url_thumbnail ? GoogleDrive.file_url(pin.metadata.parking_picture_url_thumbnail) : '';
        this.tooltip.setContent(this.tooltipTemplate.replace('{title}', title).replace('{img}', img));
        this.tooltip.open(this.map,pin);
    }

    handleDataUpdated(initCheck = false) {
        this.props.parentRefreshFunction && this.props.parentRefreshFunction(initCheck);
    }

    saveLeftSide(toCart=false, withAction="none") {
        const message = getErrorCodes(this.state.selectingInfo.errors)
    
        if(message.length > 0){
            this.props.alertModal.current.showErrorModal({messageNo:message});
            return 
        }

        let selectingInfo = this.state.selectingInfo;

        // 保留のときはコンタクトメモ必須
        var regex = new RegExp(/^[ \t　]*$/);
        if (selectingInfo.values.request_parking_status == 10 &&
            (selectingInfo.values.contact_memo == null || regex.test(selectingInfo.values.contact_memo))) {
            this.props.onErrorWithCode && this.props.onErrorWithCode(2519);
            return;
        }

        // if(toCart) {
        //     selectingInfo.values.request_parking_status = 11;
        // }
        var url = '/api/request/parking/update';
        let images = this.carouselImage.current.getImages();
        const params = {
            ...selectingInfo.values,
            parking_pictures: images.images,
            request_ulid: this.props.request_ulid,
            parking_picture_thumbnail_index: images.selected_index,
            parking_picture_url_thumbnail: images.images[images.selected_index],
            parking_picture_filelist: images.images.join(','),
            parking_latitude : selectingInfo.values.latitude,
            parking_longitude : selectingInfo.values.longitude,
            request_parking_space_qty : selectingInfo.values.request_parking_space_qty ? selectingInfo.values.request_parking_space_qty : 0,
            to_cart: toCart,
            with_action: withAction
        };
        if (!selectingInfo.values.request_parking_ulid) {
            const {
                user_branch_id,
                id
            } = this.props.requestData
            Request.post(url, {
                ...params,
                user_branch:user_branch_id,
                request:id,
                // parking:1
            }, res => {
                this.search();
                this.updateEditPin();
                this.handleDataUpdated();
            }, (err) => {
                const {status, statusText} = err.response
                this.props.onErrorWithMessage && this.props.onErrorWithMessage(status, statusText);
            });
        } else {
            url = url + '/' + selectingInfo.values.request_parking_ulid;
            Request.put(url, params, res => {
                if(res.Data.ulid){
                    this.search();
                    this.updateEditPin();
                    this.handleDataUpdated();
                }
            }, (err) => {
                const {status, statusText} = err.response
                this.props.onErrorWithMessage && this.props.onErrorWithMessage(status, statusText);
            });
        }
    }

    loadGoogleApi() {
        const callbackName = "googleAPIReady";
        let url = `https://maps.googleapis.com/maps/api/js?key=${this.state.googleMapKey}&callback=${callbackName}`;

        return new Promise((resolve, reject) => {
            lock.acquire('loadGoogleApi', () => {
                if (scriptLoaded) {
                    var id = setInterval(() => {
                        if (google) {
                            clearInterval(id);
                            resolve();
                        }
                    }, 1000);
                    return;
                }
                this.script = document.createElement("script");
                this.script.type = "text/javascript";
                this.script.async = true;
                this.script.defer = true;
                this.script.src = url;
                window.googleAPIReady = () => {
                    google = window.google;
                    this.setState({
                        center_processed:false,
                        sessionCheckInterval : setTimeout(
                        ()=>{
                            this.searchManager=undefined
                            this.mapRef.current.innerHTML=""
                            scriptLoaded = false
                            this.script=undefined
                            this.loadGoogleApi().then(() => {
                                // if(this.props.center.latitude > 0 && this.props.center.longitude > 0){
                                //     this.updateCenterPin();
                                // }else{
                                    this.initMap();
                                // }
                                                              
                            });
                        },59*60*1000)
                    })
                    resolve();
                };
                this.script.onError = (error) => {
                    reject(error);
                };
                this.mapRef.current.appendChild(this.script);
                window.GooglemapRefreshIsNeeded = true
                scriptLoaded = true
            });
        });
    }
    validate() {
        let message = getErrorCodes(this.state.selectingInfo.errors)
        
        if(message.length > 0){
          this.props.alertModal.current.showErrorModal({messageNo:message});
          return false;
        }
        return true;
    }

    validateCallback(newData, callback=()=>{}){
        const data = this.state.selectingInfo;
        this.setState({
            selectingInfo:{
            ...data,
            ...newData,
                error:{
                    parking_name:newData.values.parking_name != "" ? undefined: [GetMessage(2024)],
                    supplier_name:newData.values.supplier_name != "" ? undefined: [GetMessage(2024)],
                    supplier_tel:newData.values.supplier_tel != "" ? undefined: [GetMessage(2024)],
                },
                values:{
                    ...newData.values,
                    parking_name:newData.values.parking_name != "" ? newData.values.parking_name :"",
                    supplier_name:newData.values.supplier_name != "" ? newData.values.supplier_name :"",
                    supplier_tel:newData.values.supplier_tel != "" ? newData.values.supplier_tel :"",
                }
            }
        }, ()=>callback())
    }


    async setSelectingInfo(ulid,site=false,pin={}, callback=() => {},pinClick=false){
        // set state with ulid  data find -> selectinginfo
        const targetParking =  this.data.find(parking=>parking.ulid===ulid)
        const targetPin =  this.state.allpins.find(pins=>pins.pin.metadata.ulid && pins.pin.metadata.ulid===ulid)

        const check_ulid_flag = ulid == this.state.selectingInfo.ulid && pinClick == false
        let {parking_name,supplier_name,supplier_tel} = this.state.selectingInfo.values

        //既に選択されていたら、初期化
        if(this.state.editpin.pin && this.state.editpin.pin instanceof google.maps.Marker){
            let old_target = this.state.editpin.pin;
            // console.log(target,check_ulid_flag);
            this.editSvgPinMarker(old_target,old_target.metadata.default_color,true)
        }    
        // console.log(targetParking)
        if(!targetParking){
            let editpin = {};
            if(site == true){
                // console.log(pin)
                this.editSvgPinMarker(pin,PIN_COLOR.EMPHASIS_PIN)
                editpin.pin = pin;
                editpin.handlers = [];
            }

            this.setState({
                selectingInfo: {
                    ulid:ulid,
                    values:{
                        pin_type: PIN_TYPE.MANUAL_PIN,
                        parking_pictures:[],
                    },
                    errors:{
                        parking_name : [GetMessage(2024)],
                        supplier_name : [GetMessage(2024)],
                        supplier_tel : [GetMessage(2024)]
                    },
                    requiredData:{
                        ...this.state.selectingInfo.requiredData
                    }
                },
                clickSave:false,
                editpin:editpin,
                isParking: false,
                searchLockFlag: false
                
            }, () => {
                if(ulid){
                    this.clearDynamicPin();
                }
                callback();
            });

            return
        } else {
            // console.log("target")
            let target = await targetPin.pin;
            // console.log(target);
            this.editSvgPinMarker(target,PIN_COLOR.EMPHASIS_PIN);
            // 2022-07-03
            let parking_id = targetParking.id;

            Request.get("/api/request/parking/history",{parking_id:parking_id}, async (res)=>{
                // console.log(targetParking, res);
                // console.log(this.props)
                let history = []
                if ( res.data.length > 0 ) {
                    res.data.map((d)=>{
                        history.push(d);
                    })
                }

                let newSelectingInfo = {
                    parking_name:check_ulid_flag ? parking_name: targetParking.parking_name,
                    supplier_tel:check_ulid_flag ? supplier_tel: targetParking.supplier.supplier_tel,
                    supplier_tel_org:targetParking.supplier.supplier_tel,
                    request_parking_ulid:targetParking.request_parking.ulid,
                    request_parking_status:targetParking.request_parking.request_parking_status || 0,
                    saved_request_parking_status:targetParking.request_parking.request_parking_status || 0,
                    route_map_parking_flag:targetParking.request_parking.route_map_parking_flag  || 0,
                    request_parking_space_qty:targetParking.request_parking.request_parking_space_qty,
                    parking_ulid:targetParking.ulid,
                    parking_natural_id:targetParking.parking_natural_id,
                    longitude:targetParking.longitude,
                    latitude:targetParking.latitude,
                    update_timestamp:targetParking.request_parking.update_timestamp,
                    parking_update_timestamp:targetParking.update_timestamp,
                    supplier_update_timestamp:targetParking.supplier.update_timestamp,
                    parking_pictures:(targetParking.parking_picture_filelist && targetParking.parking_picture_filelist.split(','))||[],
                    parking_prefecture:targetParking.parking_prefecture,
                    parking_city:targetParking.parking_city,
                    parking_address:targetParking.parking_address,
                    parking_picture_url_thumbnail: targetParking.parking_picture_url_thumbnail,
                    sv_url: targetParking.sv_url,
                    site_distance_meter : targetParking.request_parking.site_distance_meter,
                    site_distance_minute : targetParking.request_parking.site_distance_minute,
                    contact_memo : targetParking.request_parking.contact_memo,
                    system_memo : targetParking.system_memo,
                    supplier_system_memo : targetParking.supplier.system_memo,
                    request_capacity_qty : targetParking.request_capacity_qty,
                    supplier_name : check_ulid_flag ? supplier_name : targetParking.supplier_name,
                    supplier_name_org : targetParking.supplier_name
                }
    
                const resetDistanceFlag = targetParking.request_parking.site_distance_meter === null ? true : false
                const { site_distance_meter, site_distance_minute} = resetDistanceFlag && await this.calcDistance(targetParking.latitude, targetParking.longitude, this.props.requestData.request_type)
                if(resetDistanceFlag){
                    newSelectingInfo = {
                        ...newSelectingInfo,
                        site_distance_meter : site_distance_meter,
                        site_distance_minute : site_distance_minute
                    }
                }
                
                this.setState({
                    selectingInfo: {
                        ulid:ulid,
                        values:newSelectingInfo,
                        errors:check_ulid_flag?this.state.selectingInfo.errors:{},
                        requiredData:{
                            ...this.state.selectingInfo.requiredData
                        },
                        history : history
                    },
                    clickSave:false,
                    editpin:targetPin,
                    isParking: true,
                    searchLockFlag: false
                }, () => {
                    this.clearDynamicPin();
                    callback();
                });
            });
        }
    }

    calcDistance(latitude, longitude, request_type){
        return new Promise(resolve => {
            const url = `/api/calcdistance?project=${this.props.center.latitude},${this.props.center.longitude}&parking=${latitude},${longitude}&request_type=${request_type}`
            // console.log(url);
            Request.get(url, {}, res => {
                // console.log(res.Data);
                let {site_distance_meter,site_distance_minute } = res.Data

                resolve({site_distance_meter, site_distance_minute})
            }
            , () => {
                this.props.alertModal.current.showErrorModal({messageNo:2477});
            }
            , undefined
            , false)
        })
    }

    addImage(croppedImageObject) {
        this.setState({
            selectingInfo: {
                values:{
                    ...this.state.selectingInfo.values,
                    parking_pictures:[
                        ...this.state.selectingInfo.values.parking_pictures,
                        croppedImageObject.id
                    ],
                    parking_picture_url_thumbnail: croppedImageObject.id
                },
                errors:{},
                requiredData:{}
            }
        })
    }

    addListener(map){
        let start = 0;
        let end = 0;
        let longpress = false;

        // モバイル（iPad）ロングタップ対応
        if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
            google.maps.event.addListener(map, 'mousedown', (event) => {
               start = new Date().getTime();
            });
    
            google.maps.event.addListener(map, 'mouseup', (event) => {
                if (start) {
                    end = new Date().getTime();
                    longpress = (end - start < 500) ? false : true;
                    
                    if(longpress){
                        this.onRightClickMap(event);
                    }
                }
            });
        }
    } 

    addCart () {
        let { 
            request_parking_status,
            request_parking_space_qty,
            route_map_parking_flag,
        } = this.state.selectingInfo.values;

        // TODO すでにカート登録済みは何もしない
        if (request_parking_status == 11) {
            return;
        }

        // 駐車場管理ステータスが2:空有または駐車場管理ステータスが3:満車（空予定）以外の場合、エラー表示
        if (request_parking_status != 1 && request_parking_status != 2) {
            this.props.onErrorWithCode && this.props.onErrorWithCode(2509);
            return;
        }
        // 見積登録候補の登録件数が16件以上の場合、エラー表示
        if (this.props.cart_total_count >= 15) {
            this.props.onErrorWithCode && this.props.onErrorWithCode(2511);
            return;
        }
        // 空き台数が0の場合、エラー表示
        if (request_parking_space_qty <= 0) {
            this.props.onErrorWithCode && this.props.onErrorWithCode(2513);
            return;
        }
        // 経路図に表示しないの場合、エラー表示
        if (route_map_parking_flag == 0) {
            this.props.onErrorWithCode && this.props.onErrorWithCode(2514);
            return;
        }

        let selectingInfoValue = this.state.selectingInfo.values;
        if(selectingInfoValue.supplier_name_org != selectingInfoValue.supplier_name ||
            selectingInfoValue.supplier_tel_org != selectingInfoValue.supplier_tel
        ) {
            // 2028 仕入先変更の登録確認ダイアログ
            this.setState({
                to_cart: true,
                searchLockFlag: true,
            }, () => {
                this.dialogSupplierUpdate.current.show()
            });
        } else {
            this.saveLeftSide(true, undefined);
        }
    }

    async searchTel(supplier_tel){
        console.log(supplier_tel)
        var url = '/api/supplier';
        const params = {
            supplier_tel : supplier_tel,
            show_delete_data : '0',
            unlimit: 1,
            count_flag: 1,
        };
        
        Request.get(url, params, res => {
            // console.log(res,res.Code == 814 )
            this.setState({
                supplier_data : {
                    selected_supplier_id: res.Data.length > 0 ? String(res.data[0].id) : null,
                    suppliers: res.Code != 814 ? res.Data : [],
                    error: res.Code == 814 ? res.Data.error : undefined
                }
            }, () => {
                // console.log(this.state.supplier_data)
            });
        })
    }

    render() {
        const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.props.requestData)
        const LeftSideSite = this.leftSideSite;
        const PinColorGuide = this.pinColorGuide;
        const site_distance_meter = Format.comma_delimited(parseInt(this.state.selectingInfo.values.site_distance_meter),"m")
        const site_distance_minute = Format.disp_time(parseInt(this.state.selectingInfo.values.site_distance_meter),this.props.requestData.request_type)
        let request_capacity_qty = this.state.selectingInfo.values.request_capacity_qty ? this.state.selectingInfo.values.request_capacity_qty : undefined 
        let images = this.carouselImage.current&&this.carouselImage.current.getImages();

        const sv_url = this.state.selectingInfo.values.sv_url;
        const streetViewUrl = sv_url ? sv_url :`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${this.state.selectingInfo.values.latitude},${this.state.selectingInfo.values.longitude}`

        // console.log('leftSide state', this.state)
        return (
            <>
                <div className="unselectable" style={{ width: "100%", height: "100%", position: "relative" }}>
                    <div ref={this.mapRef} className="map" style={{ zIndex: "500", height: '600px' }} />
                    <PinColorGuide style={{position: "absolute", top: 0, left: 0, bottom: 0, zIndex: "501", width: "500px", background: "rgba(255,255,255,0.9)", padding: '10px 25px 10px 10px'}}></PinColorGuide>
                    {(this.state.isParking
                        ? <Navbar style={{ position: "absolute", top: 0, left: 0, bottom: 27, zIndex: "501", width: "400px", background: "rgba(255,255,255,0.9)", padding: '10px 10px 10px 10px', overflowY:"scroll" }} className="map-nav navbar-dark">
                            <Container style={{border:'1px solid #344675', padding: '5px', borderRadius:'10px', marginBottom:'5px'}}>
                                駐車場 
                                {
                                    this.state.selectingInfo.values.parking_ulid &&
                                    <>
                                        <Link style={{marginLeft:'10px'}} target="_blank" to={"/parking/detail/"+this.state.selectingInfo.values.parking_ulid}>{this.state.selectingInfo.values.parking_natural_id}</Link>
                                        <a style={{marginLeft:'10px'}} target="_blank" href={streetViewUrl}>ｽﾄﾘｰﾄﾋﾞｭｰ</a>
                                    </>
                                }
                                <div className="form-group row">
                                    <div className="col-sm-4 col-form-label">駐車場名</div>
                                    <div className="col-sm-8" style={{"color":"red"}}>
                                        <InputText label="駐車場名"
                                            name="PARKING__parking_name"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            rootData={this.state.selectingInfo}
                                            validateType='regist'
                                            showValidateMessage={true}
                                            />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-4 col-form-label">仕入先名</div>
                                    <div className="col-sm-8" style={{"color":"red"}}>
                                        <InputText label="仕入先名"
                                            name="SUPPLIER__supplier_name"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            rootData={this.state.selectingInfo}
                                            validateType='regist'
                                            showValidateMessage={true}
                                            />
                                     </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-4 col-form-label">TEL</div>
                                    <div className="col-sm-8" style={{"color":"red"}}>
                                        <InputText label="電話番号"
                                            name="SUPPLIER__supplier_tel"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            rootData={this.state.selectingInfo}
                                            validateType='regist'
                                            showValidateMessage={true}
                                            />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-4 col-form-label">駐車場住所</div>
                                    <div className="col-sm-8 col-form-label" style={{
                                        fontSize: '0.75rem',
                                        height: '60px',
                                        overflowY:'scroll'
                                    }}>
                                        {Definition.item('___JOIN_parking_addr_sub', this.state.selectingInfo.values)}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-5 col-form-label">現場距離<br/>計算結果{request_capacity_qty&&<><br/>依頼台数</>}</div>
                                    <div className="col-sm-7 col-form-label" >{site_distance_minute}<br/>{site_distance_meter}{request_capacity_qty&&<><br/>{request_capacity_qty}台</>}</div>
                                </div>
                                <div style={{position:"relative", marginTop:-50}}>
                                    <span className="text-right" style={{zIndex:"1000", right: '0', position:"absolute", display: 'block', bottom : 0}}>
                                        <ImageControl 
                                            uploadCallback={(croppedImageObject)=>{
                                                this.addImage(croppedImageObject)
                                            }}
                                            imageButton = {true}
                                        />
                                    </span>
                                    <span style={{ width: "100%", zIndex: 999, display:'block', position:'relative' }}>
                                        <CarouselImage 
                                            ref={this.carouselImage} 
                                            image_items={this.state.selectingInfo.values.parking_pictures?this.state.selectingInfo.values.parking_pictures:[]} 
                                            initialIndex = {this.state.selectingInfo.values.parking_pictures&&this.state.selectingInfo.values.parking_pictures.findIndex(id=>id==this.state.selectingInfo.values.parking_picture_url_thumbnail)}
                                            height={"200px"}
                                            mgClassName={this.props.isSurvey ? "mgt0" : ""}
                                        />
                                        <Row>
                                            <Col>
                                                <button style={{marginBottom: "5px", border: "none", background: "transparent"}} onClick={() => this.addCart()}><img style={{ cursor: 'pointer' }} src="/cart_add.svg" width="40" height="40" alt="empty" /></button>
                                            </Col>
                                            <Col>
                                                {(images&&images.images.length&&images.images.length<1)?<img style={{}} src="/camera-solid.svg" width="100" height="100" alt="empty" />:''}
                                            </Col>
                                        </Row>

                                    </span>
                                </div>
                            </Container>

                            <Container id="survey-status" style={{border:'1px solid #344675', padding: '5px', borderRadius:'10px'}}>
                                調査状況
                                <Row className="form-group row">
                                    <span className="col-sm-5 col-form-label">調査状況</span>
                                    <Col className="col-sm-7"> 
                                        <InputSelectClearUndefined label="調査状況"
                                            name="REQUEST_PARKING__request_parking_status"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            options={cst_request_parking_status.filter((d) => { return d.value != 11 })} // 11:見積候補登録済み　はドロップダウンに出さない
                                            rootData={this.state.selectingInfo}
                                            isClearable={false}
                                            isSurvey={this.props.isSurvey ? this.props.isSurvey : false}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group row">
                                    <span className="col-sm-5 col-form-label">経路図</span>
                                    <Col className="col-sm-7">
                                        <InputSelect label="調査状況"
                                            name="REQUEST_PARKING__route_map_parking_flag"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            options={cst_route_map_parking_flag}
                                            rootData={this.state.selectingInfo}
                                            isClearable={false}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group row">
                                    <span className="col-sm-5 col-form-label">空台数</span>
                                    <Col className="col-sm-5" style={{paddingLeft:0, paddingRight:0}}>
                                        <InputNumber label="空台数"
                                            name="REQUEST_PARKING__request_parking_space_qty"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            rootData={this.state.selectingInfo}
                                            validateType='regist' 
                                            size={12}
                                            showValidateMessage={false}
                                        />
                                    </Col>
                                    <span className="col-sm-2 col-form-label" style={{paddingLeft:0}}>台</span>
                                </Row>
                                {/* 2022/07/04 yj.sato */}
                                <Row className="form-group row">
                                    <Col className="col-sm-12" style={{paddingLeft:15, paddingRight:15}}>
                                        <span className="col-form-label">コンタクトメモ</span>
                                        <InputText label="コンタクトメモ"
                                            name="REQUEST_PARKING__contact_memo"
                                            labelOn={false} 
                                            validateCallback={this.validateCallback} 
                                            rootData={this.state.selectingInfo}
                                            validateType='regist' 
                                            multiline={true}
                                            showValidateMessage={false}
                                        />
                                    </Col>
                                </Row>
                                {this.state.selectingInfo.history && (<>
                                    {this.state.selectingInfo.history.length>0 && (<>
                                        過去の履歴（直近３件）
                                        {this.state.selectingInfo.history.map((log,i)=>{
                                            let request_parking_status = cst_request_parking_status.find(status=>log.request_parking_status == status.value)
                                            // console.log(request_parking_status);

                                            return (<>
                                            {i > 0 && (<>
                                                <hr style={{borderStyle:"dashed", borderColor:"darkgray"}} />
                                            </>)}
                                            <Row>
                                                <Col>
                                                <table border="0">
                                                    <tr><td width="60px">更新日</td><td>{log.f_update_timestamp}</td></tr>
                                                    <tr><td>更新者</td><td>{log.lastupdate_user}</td></tr>
                                                    <tr><td>調査状況</td><td>{request_parking_status.label}</td></tr>
                                                </table>
                                                コンタクトメモ<br/>
                                                {log.contact_memo ?
                                                    log.contact_memo.split('\n').map((item, index) => {
                                                        return <>{item}<br/></>
                                                    })
                                                 : ''}
                                                </Col>
                                            </Row>
                                        </>)})}
                                    </>)}
                                </>)}
                                <Row>
                                    <span className="col-form-label">仕入先管理情報メモ<br/>
                                    {this.state.selectingInfo.values.supplier_system_memo ? this.state.selectingInfo.values.supplier_system_memo.split('\n').map((item, index) => {
                                        return <>{item}<br/></>
                                    }) : ''}
                                    </span>
                                </Row>
                                <Row>
                                    <span className="col-form-label">駐車場管理情報メモ<br/>
                                    {this.state.selectingInfo.values.system_memo ? this.state.selectingInfo.values.system_memo.split('\n').map((item, index) => {
                                        return <>{item}<br/></>
                                    }) : ''}
                                    </span>
                                </Row>
                            </Container>
                            <Container style={{marginTop:'10px'}}>
                                <Row>
                                    <Col style={{paddingRight:'0px'}}>
                                        <Button
                                            size="sm"
                                            onClick={async() => {
                                                // 入力内容リセット
                                                if(this.state.selectingInfo.ulid) {
                                                    this.setSelectingInfo(this.state.selectingInfo.ulid);
                                                } else {
                                                    const {latitude,longitude} = this.state.selectingInfo.values;
                                                    const { site_distance_meter, site_distance_minute} = await this.calcDistance(latitude,longitude);
                                                    this.setSelectingInfo("",false,{}, () => {
                                                        this.setState({
                                                            selectingInfo : {
                                                                ...this.state.selectingInfo,
                                                                values : {
                                                                    ...this.state.selectingInfo.values,
                                                                    latitude,
                                                                    longitude,
                                                                    site_distance_meter,
                                                                    site_distance_minute
                                                                }
                                                            },
                                                            isParking: true,
                                                            searchLockFlag: false
                                                        })
                                                    });
                                                }
                                            }}
                                        >
                                            リセット
                                        </Button>
                                    </Col>
                                    <Col>
                                        <ButtonWithRole
                                            button_id="BTN_C1_02_01680"
                                            size="sm"  
                                            onClick={async () => {
                                                if (!this.validate()) {
                                                    this.props.alertModal.current.showErrorModal({messageNo:2401})
                                                    return
                                                }
                                                const selectingInfoValue = this.state.selectingInfo.values;
                                                if('parking_ulid' in selectingInfoValue &&
                                                    'request_parking_status' in selectingInfoValue &&
                                                    'saved_request_parking_status' in selectingInfoValue &&
                                                    selectingInfoValue.saved_request_parking_status == 11 &&
                                                    selectingInfoValue.request_parking_status != 11) {
                                                    // 見積登録候補登録済み(11)からそれ以外のステータスに変更した場合は確認メッセージ
                                                    this.props.alertModal.current.confirmCheck({messageNo:2512},()=>{
                                                        if(selectingInfoValue.supplier_name_org != selectingInfoValue.supplier_name ||
                                                            selectingInfoValue.supplier_tel_org != selectingInfoValue.supplier_tel
                                                        ) {
                                                            // 2028 仕入先変更の登録確認ダイアログ
                                                            this.setState({
                                                                to_cart: false,
                                                                searchLockFlag: true,
                                                            }, () => {
                                                                this.searchTel(selectingInfoValue.supplier_tel)
                                                                this.dialogSupplierUpdate.current.show()
                                                            });
                                                        } else {
                                                            this.saveLeftSide(false, undefined);
                                                        }
                                                    });

                                                } else {
                                                    if(selectingInfoValue.supplier_name_org != selectingInfoValue.supplier_name ||
                                                        selectingInfoValue.supplier_tel_org != selectingInfoValue.supplier_tel
                                                    ) {
                                                        // 2028 仕入先変更の登録確認ダイアログ
                                                        this.setState({
                                                            to_cart: false,
                                                            searchLockFlag: true,
                                                        }, () => {
                                                            this.searchTel(selectingInfoValue.supplier_tel)
                                                            this.dialogSupplierUpdate.current.show()
                                                        });
                                                    } else {
                                                        this.saveLeftSide(false, undefined);
                                                    }
                                                }
                                            }}
                                        >
                                            保存
                                        </ButtonWithRole>
                                    </Col>
                                    {/* <Col><Button size="sm" onClick={() => { this.editDialog.current.show(this.state.selectingInfo); }}>マスタ編集</Button></Col> */}
                                </Row>
                                <Row>
                                    <Col>
                                        
                                    </Col>
                                </Row>
                            </Container>
                        </Navbar>
                        : <LeftSideSite /> )
                    }
                </div>
                <ErrorDialog ref={this.errorDialog} class="error-dialog" />
                <DialogConfirm 
                    ref={this.dialogConfirm} 
                    {...this.props}
                    newSiteLocation = {this.state.newSiteLocation}
                    positive={true}
                    clearDynamicPin={() => {this.clearDynamicPin()}}
                    parentUpdateSiteLocation = {() => {this.parentUpdateSiteLocation()}}
                />
                <DialogSupplierUpdate 
                    ref={this.dialogSupplierUpdate} 
                    {...this.props}
                    selectingInfo={this.state.selectingInfo}
                    supplier_data={this.state.supplier_data}
                    clickSave={this.state.clickSave}
                    clickNew={() => {
                        // 新たな仕入先として登録
                        this.saveLeftSide(this.state.to_cart, "new_supplier");
                    }}
                    clickLink={(supplier_id) => {
                        // 仕入先名と紐づけて登録
                        this.setState({
                            selectingInfo : {
                                ...this.state.selectingInfo,
                                values : {
                                    ...this.state.selectingInfo.values,
                                    select_supplier_id: supplier_id
                                }
                            }
                        }, () => {
                            this.saveLeftSide(this.state.to_cart, "link_supplier");
                        })
                    }}
                    clickUpdate={(supplier_id) => {
                        // 仕入先名を上書きして登録
                        this.setState({
                            selectingInfo : {
                                ...this.state.selectingInfo,
                                values : {
                                    ...this.state.selectingInfo.values,
                                    select_supplier_id: supplier_id
                                }
                            }
                        }, () => {
                            this.saveLeftSide(this.state.to_cart, "update_supplier");
                        })
                    }}
                    setLockFlag={(flag)=>{
                        this.setState({
                            searchLockFlag: flag
                        })
                    }}
                />
            </>
        );
    }

    async initMap(lat=35.6731706,lng=139.7386161) {
        let mapOptions = { center: {lat: lat,lng: lng} };

        if (this.props.aerial) {
            mapOptions.mapTypeId = google.maps.MapTypeId.HYBRID;
        }

        mapOptions.zoom = this.props.zoom ? this.props.zoom : 18;
        mapOptions.minZoom = 12.0; // ズーム　引きの限界
        mapOptions.maxZoom = 21; // ズーム　寄りの限界
        mapOptions.disableScrollWheelZoom = true;
        mapOptions.streetViewControl = false;
        mapOptions.zoomControl = true;
        mapOptions.zoomControlOptions = {position:google.maps.ControlPosition.RIGHT_TOP};
        mapOptions.cameraControlOptions = {position:google.maps.ControlPosition.RIGHT_CENTER};
        // https://lab.syncer.jp/Web/API/Google_Maps/JavaScript/MapTypeStyle/
        mapOptions.styles =  [
            { featureType: 'poi',stylers: [{ visibility: 'off' }]},
            { featureType: 'landscape.man_made',stylers: [{ visibility: 'on' }]},
        ];
        mapOptions.tilt = 0;

        this.map = new google.maps.Map(this.mapRef.current, mapOptions);
        this.marker_clusterer = new MarkerClusterer({map: this.map});

        // bounds_changedじゃないとtooltipで地図が自動でずれたときに対応できなそう
        // 地図描画初回もbound_changeが呼ばれてるので projection_changedは併用しない
        // google.maps.event.addListener(this.map, 'bounds_changed', () => {
        //     console.log("bounds_changed");
        //     this.boundsUpdate();
        // });
        // // 地図ドラッグが終わったタイミングでピン再取得
        // google.maps.event.addListener(this.map, 'dragend', () => {
        //     console.log("dragend"); 
        //     // this.search();
        //     // this.boundsUpdate();
        //  });
        // ズームレベルが変わったタイミングでピン再取得
        // google.maps.event.addListener(this.map, 'zoom_changed', () => {
        //     // this.boundsUpdate();
        // });
        // マップ読み込み完了タイミングで角取得（map初期化後すぐだと取れない）
        google.maps.event.addListener(this.map, 'projection_changed', () => {
            this.props.mapReady && this.props.mapReady();
            // console.log("projection_changed");
            // this.boundsUpdate();
        });
        google.maps.event.addListener(this.map, 'idle', () => {
            // console.log("idle");
            this.boundsUpdate();
        });

        if (this.state.editable) {
            google.maps.event.addListener(this.map, 'click', this.onClickMap);
            google.maps.event.addListener(this.map, 'rightclick', this.onRightClickMap);
        }

        // infowindowを非表示に（システム以外のデフォルトPOI）
        var set = google.maps.InfoWindow.prototype.set;
        google.maps.InfoWindow.prototype.set = function(key, val) {
            if (key === "map") {
                if (! this.get("noSuppress")) {
                    return;
                }
            }
            set.apply(this, arguments);
        }


        // console.log('init Map executed')

        // 権限チェック        
        const unUsable = isDisabledByRole("BTN_C1_02_01530", this.props.buttons, this.props.requestData)
        
        this.tooltip = new google.maps.InfoWindow({noSuppress: true});

        this.infobox_for_dynamic_pin = new google.maps.InfoWindow({
            content:unUsable?'駐車場新規追加の権限がありません。':'<div id="parking_add">この場所へ駐車場を新規追加する</div>',
            noSuppress: true
        });


        this.infobox_for_dynamic_pin.setMap(this.map);
        if (!unUsable) {
            google.maps.event.addListener(this.infobox_for_dynamic_pin, 'closeclick', async() => {
                this.removePin(this.dynamic_pininfo);
            });
            google.maps.event.addListener(this.infobox_for_dynamic_pin, 'domready', async() => {
               
                document.getElementById('parking_add').addEventListener('click', async() => {
                    this.infobox_for_dynamic_pin.close();
                    // console.log(this.state.selectingInfo.values);
                    const {latitude,longitude} = this.state.selectingInfo.values;
                    const { site_distance_meter, site_distance_minute} = await this.calcDistance(latitude,longitude)
                    this.setSelectingInfo("",false,{}, () => {
                        this.setState({
                            selectingInfo : {
                                ...this.state.selectingInfo,
                                values : {
                                    ...this.state.selectingInfo.values,
                                    latitude,
                                    longitude,
                                    site_distance_meter,
                                    site_distance_minute
                                }
                            },
                            isParking: true,
                            searchLockFlag: false,
                        })
                    });
                });
            });
        }

        this.handleDataUpdated(true);
        this.addListener(this.map);
    }

    boundsUpdate() {
        this.bounds = this.map.getBounds();
        const base = 10000;
        
        if(this.prev_bounds != null &&
            this.orgFloor(this.prev_bounds.getNorthEast().lng(),base) == this.orgFloor(this.bounds.getNorthEast().lng(),base) &&
            this.orgFloor(this.prev_bounds.getNorthEast().lat(),base) == this.orgFloor(this.bounds.getNorthEast().lat(),base) &&
            this.orgFloor(this.prev_bounds.getSouthWest().lng(),base) == this.orgFloor(this.bounds.getSouthWest().lng(),base) &&
            this.orgFloor(this.prev_bounds.getSouthWest().lat(),base) == this.orgFloor(this.bounds.getSouthWest().lat(),base)) {
                return;
        }
        this.prev_bounds = this.bounds;
        this.search();
    }

    orgFloor(value, base) {
        return Math.floor(value * base) / base;
    }

    geocodeQuery(query) {
        const geoUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${query}&key=${this.state.googleMapKey}&components=country:JP`

        Request.get(geoUrl,{}, res => {
            if (res && res.data && res.data.results && res.data.results.length > 0) {

                const loctaion = res.data.results[0].geometry.location;
                const {lat,lng} = loctaion;

                this.initMap(lat,lng);

                this.props.onLocationChange && this.props.onLocationChange(lat,lng);
                this.removePin(this.dynamic_pininfo);
                this.dynamic_pininfo = this.addPin(loctaion); 

            }
          }, (err) => {
            console.log('GoogleMapApi errorCallback :', err)
          }, () => {}, false, false, false
        )
    }
    pinColorGuide = () => {
        const SvgPinTag = this.svgPinTag;
        // 以下サンプルカラーのためparking_statusは全部REGISTERED_PINに固定しているがREGISTERED_ADD_PINなども同じ色のため共通色として
        return <div style={{ position: "absolute", bottom: 30, right: 55, zIndex: "501", width: "60%", cursor:"pointer" }} >
            <table style={{ height: '120px', borderCollapse: "collapse", borderSpacing: 0}} >
                <tr>
                    {this.state.pin_color_guide_open ?
                    <td style={{height: '100%', background: "rgba(255,255,255,0.9)", padding: '10px 25px 10px 10px'}}>
                        凡例:&nbsp;
                        <SvgPinTag parking_status="" pintype={PIN_TYPE.CURRENT_POSITION_PIN}/>現場&nbsp;
                        0:<SvgPinTag parking_status="0" pintype={PIN_TYPE.REGISTERED_PIN}/>未確認&nbsp;
                        1:<SvgPinTag parking_status="1" pintype={PIN_TYPE.REGISTERED_PIN}/>空有&nbsp;
                        2:<SvgPinTag parking_status="2" pintype={PIN_TYPE.REGISTERED_PIN}/>満車（空予定）&nbsp;
                        3:<SvgPinTag parking_status="3" pintype={PIN_TYPE.REGISTERED_PIN}/>満車&nbsp;
                        4:<SvgPinTag parking_status="4" pintype={PIN_TYPE.REGISTERED_PIN}/>短期不可&nbsp;
                        5:<SvgPinTag parking_status="5" pintype={PIN_TYPE.REGISTERED_PIN}/>不特定不可&nbsp;
                        6:<SvgPinTag parking_status="6" pintype={PIN_TYPE.REGISTERED_PIN}/>外部不可&nbsp;
                        7:<SvgPinTag parking_status="7" pintype={PIN_TYPE.REGISTERED_PIN}/>契約不可&nbsp;
                        8:<SvgPinTag parking_status="8" pintype={PIN_TYPE.REGISTERED_PIN}/>閉鎖&nbsp;
                        9:<SvgPinTag parking_status="9" pintype={PIN_TYPE.REGISTERED_PIN}/>電話不通&nbsp;
                        10:<SvgPinTag parking_status="10" pintype={PIN_TYPE.REGISTERED_PIN}/>保留&nbsp;
                        11:<SvgPinTag parking_status="11" pintype={PIN_TYPE.REGISTERED_PIN}/>見積登録候補登録済み&nbsp;
                        <br/>
                        ●:表示しない&nbsp;★:表示する
                        <br/>
                        <SvgPinTag parking_status="" pintype={PIN_TYPE.PROHIBITED_PIN}/>出入禁止&nbsp;
                    </td>
                    : <td style={{ width: '100%' }}></td>}
                    <td style={{ background:'rgba(255,255,255,0.9)', width: '15px', height: '100%', color: 'blue', verticalAlign: 'middle', textAlign: 'center', lineHeight: '50px' }} onClick={() => { this.pinColorGuideSwitch(); }}>
                            {this.state.pin_color_guide_open ? '◀' : '▶'}
                    </td>
                </tr>
            </table>
        </div>
    }
    leftSideSite = () => {
        // console.log("this.props >> ", this.props)
        // console.log("this.state >> ", this.state)

        const {requestData} = this.props;
        const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.props.requestData)
        return <Navbar style={{ position: "absolute", top: 0, left: 0, zIndex: "501", width: "300px", background: "rgba(255,255,255,0.9)", padding: '10px 10px 10px 10px' }} className="map-nav navbar-dark">
                <Container style={{border:'1px solid #344675', padding: '5px', borderRadius:'10px', marginBottom:'5px'}}>
                    現場 
                    {
                        requestData.project_ulid &&
                        <>
                            <Link style={{marginLeft:'10px'}} target="_blank" to={"/construction/detail/"+requestData.project_ulid}>{requestData.project_natural_id}</Link>
                        </>
                    }
                    <div className="form-group row">
                        <div className="col-sm-4 col-form-label">現場名</div>
                        <div className="col-sm-8">
                            {requestData.site_name}
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-4 col-form-label">現場場住所</div>
                        <div className="col-sm-8 col-form-label" style={{
                            fontSize: '0.75rem',
                            height: '60px',
                            overflowY:'scroll'
                        }}>
                            {Definition.item('___JOIN_project_addr', requestData)}
                        </div>
                    </div>
                </Container>
                <Container style={{marginTop:'10px'}}>
                    <Row>
                        <Col>
                            <Button
                                size="sm"
                                onClick={() => {
                                    this.setSelectingInfo("",true,this.current_position_pin);
                                }}
                            >
                                リセット
                            </Button>
                        </Col>
                        <Col>
                            <ButtonWithRole
                                button_id="BTN_C1_02_01680"
                                size="sm"  
                                onClick={() => { this.dialogConfirm.current.show() }}
                            >
                                保存
                            </ButtonWithRole>
                        </Col>
                    </Row>
                </Container>
            </Navbar>
    }
}

class ErrorDialog extends DialogBase {
    constructor(props) {
        super(props);

        Object.assign(this.state, {
            title: 'エラー',
            size: 'sm',
            positive: true,
            negative: false,
            message: ''
        });
    }

    show(message) {
        this.setState({ message: message }, () => { super.show(); });
    }

    bodyContent() {
        return (
            <>
                {this.state.message}
            </>
        );
    }
}

export class DialogConfirm extends DialogBase {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            title:"現場位置を移動します。よろしいですか？",
            dialogData : {
                ...this.state.dialogData,
                requiredData:{},
                errors : {}
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location !== this.props.location){
            this.setState({
                dialogData : {
                    ...this.state.dialogData,
                    values : {},
                    errors : {}
                }
            });
        }
    }

    handleClickNegative(){
        this.toggleModal();
    }

    handleClickPositive() {
        const { 
            newSiteLocation,
            center
         } = this.props;
        const params = {
            site_change : true,
            request_ulid : this.props.requestData.ulid,
            update_timestamp : this.props.requestData.project_update_timestamp,
            latitude : newSiteLocation ? newSiteLocation.latitude : center.latitude,
            longitude : newSiteLocation ? newSiteLocation.longitude : center.longitude,
            project_id : this.props.requestData.project_id
        }

        Request.post("/api/request/parking/initialize", params , res => {
            this.props.parentUpdateSiteLocation();
            this.toggleModal();
        });
    }

    bodyContent() {
        return (<>現場位置を移動する場合、調査中の駐車場との距離が再計算されます。</>);
    }
}

export class DialogSupplierUpdate extends DialogBase {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            title:"登録確認",
            positive: false,
            newtral: false,
            negative: false,
            selectingInfo:{
                ...this.props.selectingInfo,
                values:{
                    ...this.props.selectingInfo.values,
                    parking_name: this.props.selectingInfo.values.parking_name ? this.props.selectingInfo.values.parking_name : "",
                    supplier_name: this.props.selectingInfo.values.supplier_name ? this.props.selectingInfo.values.supplier_name : "",
                    supplier_tel: this.props.selectingInfo.values.supplier_tel ? this.props.selectingInfo.values.supplier_tel : "",
                }
            },
            searchFlag: true,
            clickSave: false,
            dialogData : {
                suppliers: [],
                selected_supplier_id: null,
                requiredData:{},
                errors : {}
            }
        }

        this.handleClickNew = this.handleClickNew.bind(this);
        this.handleClickLink = this.handleClickLink.bind(this);
        this.handleClickUpdate = this.handleClickUpdate.bind(this);
        this.handleClickNegative = this.handleClickNegative.bind(this);
        this.handle_change = this.handle_change.bind(this)
        this.handle_keyDown = this.handle_keyDown.bind(this);        
    }

    search(supplier_tel) {

    }
    componentDidMount(){
        this.setState({
            selectingInfo:{
                ...this.props.selectingInfo,
                values:{
                    ...this.props.selectingInfo.values,
                }
            },
        }, () => {
            // console.log(this.state.selectingInfo,this.props.selectingInfo)
        })
    }
    componentDidUpdate(prevProps, prevState) {
        const {parking_name,supplier_name,supplier_tel} = this.props.selectingInfo.values;

        if(prevProps.selectingInfo != this.props.selectingInfo && parking_name != "" && supplier_name != "" && supplier_tel != ""){
            this.setState({
                selectingInfo:{
                    ...this.props.selectingInfo,
                    values:{
                        ...this.props.selectingInfo.values,
                        parking_name: parking_name,
                        supplier_name: supplier_name,
                        supplier_tel: supplier_tel,
                    }
                },
            }, () => {
                // console.log(this.state.selectingInfo,this.props.selectingInfo)
            })
    
        }
        if(prevProps.supplier_data != this.props.supplier_data){
            // console.log(this.props.suppliers)
            this.setState({
                dialogData:{
                    ...this.state.dialogData,
                    ...this.props.supplier_data
                }
            }, () => {
                console.log(this.state.dialogData,this.props.supplier_data)
            })
        }
    }

    footerContent() {
        return (
            <>
                <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
                <Button color="secondary" onClick={this.handleClickNew}>新たな仕入先として登録</Button>
                {this.state.dialogData.suppliers.length > 0 ? <>
                    <Button color="secondary" disabled={this.state.dialogData.error != undefined} onClick={this.handleClickLink}>仕入先名と紐づけて登録</Button>
                    <Button color="secondary" disabled={this.state.dialogData.error != undefined} onClick={this.handleClickUpdate}>仕入先名を上書きして登録</Button>
                </> : <></>}
            </>
        );
    }

    handleClickNegative(){
        this.props.setLockFlag(false)
        this.toggleModal();
    }

    handleClickNew() {
        this.props.clickNew();
        this.props.setLockFlag(false)
        this.toggleModal();
    }

    handleClickLink() {
        console.log(this.state.dialogData.selected_supplier_id)
        this.props.clickLink(this.state.dialogData.selected_supplier_id);
        this.props.setLockFlag(false)
        this.toggleModal();
    }

    handleClickUpdate() {
        console.log(this.state.dialogData.selected_supplier_id)
        this.props.clickUpdate(this.state.dialogData.selected_supplier_id);
        this.props.setLockFlag(false)
        this.toggleModal();
    }

    handle_change(e) {
        console.log(e.target.value)
        this.setState({
            dialogData : {
                ...this.state.dialogData,
                selected_supplier_id: e.target.value,
            }
        }, () => {
            console.log(this.state.dialogData)
        });
    }

    handle_keyDown(e) {
        if (e.keyCode == 13) {
            super.focusNextNode(e);
        }
    }

    bodyContent() {
        return (<>
        入力した電話番号は仕入先マスタに登録済みとなっています<br/>
        仕入先名を上書きしますか？<br/>
        ※仕入先名が複数ある場合、上書きする仕入先を選択してください<br/>
        <br/>
        <span>駐車場名:</span><span>{this.state.selectingInfo.values.parking_name}</span>&nbsp;&nbsp;
        <span>仕入先名:</span><span>{this.state.selectingInfo.values.supplier_name}</span>&nbsp;&nbsp;
        <span>仕入先TEL:</span><span>{this.state.selectingInfo.values.supplier_tel}</span><br/>
        <table style={{"width":"100%"}}>
            <tr>
                <td style={{ verticalAlign: 'top',"width": "150px" }}>登録済み仕入先名：</td>
                <td>
                    {this.state.dialogData.error != "" ? (
                        <div style={{ color: 'red'}} dangerouslySetInnerHTML={{__html:this.state.dialogData.error}}/>
                    ) : ""}
                    <div style={{"maxHeight":"200px","width":"100%","overflow":'auto'}}>
                    {this.state.dialogData.suppliers.length > 0  && this.state.dialogData.suppliers.map((data, index) => (
                        <>
                            <label key={`supplier000-${index}`}>
                                <Input className={`tabable`} type="radio" name='supplier000' id={`supplier000-${data.id}`} value={data.id} checked={String(this.state.dialogData.selected_supplier_id) === String(data.id)} onChange={this.handle_change}
                                    onKeyDown={(e) => this.handle_keyDown(e)} />{data.supplier_name}&nbsp;
                            </label>
                            <br/>
                        </>
                    ))}
                    </div>
                </td>
            </tr>
        </table>
        </>);
    }
}